import React, { ReactNode } from 'react';
import { Text } from '../../components/Text';

export const CardSubHeading: React.FC<{children: ReactNode}> = ({ children }) => {
    return (
        <div style={{marginTop: -10}}>
            <Text type="detail">{children}</Text>
        </div>
    );
};
